import { buildCanonicalRoomAliasPath } from '../features/rooms/roomChatRoutes';
import { getRoomsBasePath, getRoomTabPath } from '../service/constants';

const buildGraveRoute = (slug, query = '') => {
  if (!slug) return null;
  return query ? `/graves/${slug}?${query}` : `/graves/${slug}`;
};

const normalizeRoomTargetPath = (targetPath) => {
  const normalizedTarget = String(targetPath || '');
  if (!normalizedTarget.startsWith('/')) return targetPath;
  const [pathAndSearch, hashValue = ''] = normalizedTarget.split('#', 2);
  const [pathname, searchValue = ''] = pathAndSearch.split('?', 2);
  return (
    buildCanonicalRoomAliasPath({
      pathname,
      search: searchValue ? `?${searchValue}` : '',
      hash: hashValue ? `#${hashValue}` : '',
    }) || targetPath
  );
};

const buildMemberRoute = (slug, query = '') => {
  if (!slug) return null;
  return query ? `/members/${slug}?${query}` : `/members/${slug}`;
};

const getNotificationTarget = (notification) => {
  if (!notification) return null;
  const extra = notification.extra_info || {};

  if (notification.category === 'group_invitation_notification') {
    if (notification.show_button) return null;
    const conversationId = extra.conversation_id || extra.conversationId;
    return conversationId ? `/messages/groups/${conversationId}` : '/messages';
  }

  if (notification.category === 'room_invitation_notification') {
    if (notification.show_button) return null;
    const roomId = extra.room_id || extra.roomId;
    return roomId
      ? getRoomTabPath(encodeURIComponent(String(roomId)), 'members_chat')
      : getRoomsBasePath();
  }

  if (notification.category === 'group_join_request_notification' && notification.show_button) {
    return null;
  }

  if (notification.target_path) return normalizeRoomTargetPath(notification.target_path);
  if (extra.target_path) return normalizeRoomTargetPath(extra.target_path);

  const slug = extra.slug || extra.grave_slug;
  const userSlug = extra.user_slug || extra.connected_user_slug;

  if (extra.spark_path) return extra.spark_path;
  if (extra.spark_id) return `/sparks?spark=${extra.spark_id}`;

  if (extra.memory_path) return extra.memory_path;
  if (extra.memory_id) {
    if (slug) {
      const params = new URLSearchParams({ memory: extra.memory_id });
      if (extra.memory_entry_id) params.set('id', extra.memory_entry_id);
      if (extra.photo_id) params.set('photo', extra.photo_id);
      if (extra.video_id) params.set('video', extra.video_id);
      if (extra.music_id) params.set('music', extra.music_id);
      return buildGraveRoute(slug, params.toString());
    }
    if (userSlug) {
      return buildMemberRoute(userSlug, `tab=grave_memories&memory=${extra.memory_id}`);
    }
  }

  if (extra.grave_image_id && slug) {
    const query = new URLSearchParams({
      tab: extra.image_tab || 'photos',
      id: extra.grave_image_id,
    }).toString();
    return buildGraveRoute(slug, query);
  }

  if (extra.life_event_id && slug) {
    return buildGraveRoute(slug, `tab=events&event_id=${extra.life_event_id}`);
  }

  if (extra.frame_id && slug) {
    const params = new URLSearchParams({ apply: 'frame', frame_id: extra.frame_id });
    return buildGraveRoute(slug, params.toString());
  }

  if (extra.gift_id && slug) {
    const params = new URLSearchParams({ send: 'gift', gift_id: extra.gift_id });
    if (extra.event_id) params.set('event_id', extra.event_id);
    return buildGraveRoute(slug, params.toString());
  }

  if (slug) return buildGraveRoute(slug);
  if (userSlug) return buildMemberRoute(userSlug);

  return null;
};

export default getNotificationTarget;
